// extracted by mini-css-extract-plugin
module.exports = {"container":"Tabs_container__l5DHu","tabItem":"Tabs_tabItem__b_JVR","tabItemSelected":"Tabs_tabItemSelected__Nt0wr"};